// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"9":"8300920e","78":"367051f6","113":"e578eacc","287":"0595095a","319":"5261704b","337":"86f4bac2","372":"16cefb2f","481":"2cd409e8","488":"3993ea15","489":"6c72c08d","783":"d64c37b2","877":"51ceb241","919":"2d99d72f","921":"71ee4c5f","981":"c60b01f4"}[chunkId] + ".chunk.js";
};